/**
 * Generic pages strings.
 *
 * Namespace: pages
 */
export const pages = {
  // 404 page
  notFound: {
    code: "404",
    title: "Az oldal nem található",
    message: "A keresett oldal nem létezik vagy áthelyezésre került.",
    goHomeButton: "Főoldal",
    signInButton: "Bejelentkezés",
  },
} as const;

export type PagesMessages = typeof pages;
